module.exports = __webpack_public_path__ + "static/media/pic_fenxing.a02b5138.png";